var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},_vm._l(([
      'Оплата',
      'Доставка',
      'Статус заказа',
      'Отзывы',
      'О нас',
      'Контакты' ]),function(item,i){return _c('a',{key:i,staticClass:"nav__link",attrs:{"href":"#"}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }